import React from "react";
import CustomButton from "../custom/Button";
import { useDisclosure, Box, Center, Text } from "@chakra-ui/react";
import { Icon } from '@iconify/react';
import AddProductModal from "./AddProductModal";
import { UseFormReturnType } from "@mantine/form";

type AddProductProps = {
  product_type: string;
  mutation: any;
  form: UseFormReturnType<ProductInitialValueType, (values: ProductInitialValueType) => ProductInitialValueType>
}

export interface ProductInitialValueType {
  name: string;
  description: string;
  price: any[];
  images: string[];
}

const AddProduct: React.FC<AddProductProps> = ({ 
  product_type,
  mutation,
  form
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const handleMutation = (values: ProductInitialValueType) => {
    mutation.mutate(values)
  }

  return (
    <React.Fragment>
      <CustomButton onClick={onOpen} style={{ height: '100%', width: '100%' }}>
        <Center
          borderRadius='10px'
          borderWidth="2px"
          borderStyle="dashed"
          borderColor="#B5BAC1"
          px={4}
          h="100%"
          py={35}
        >
          <Box>
            <Box display='flex' justifyContent='center'>
              <Icon
                icon="material-symbols:add-circle-rounded"
                color="#37a75b" width="40" height="40"
              />
            </Box>

            <Text
              fontWeight='semibold' mt={2}
              fontSize='xl' color='#B5BAC1'>
              Add {product_type}
            </Text>
          </Box>
        </Center>
      </CustomButton>

      <AddProductModal 
        mutation={mutation}
        isOpen={isOpen}
        onClose={onClose}
        form={form} 
        handleMutation={handleMutation}
      />
    </React.Fragment>
  )
}

export default AddProduct